/**
 * Phone Authentication Service
 * 전화번호 OTP 인증을 위한 서비스
 */

import { twilioService } from './twilio';
import { supabase } from './supabase';

class PhoneAuthService {
  /**
   * OTP 발송
   * @param {string} phone - 전화번호 (E.164 형식)
   * @returns {Promise<{data: any, error: any}>}
   */
  async sendOTP(phone) {
    try {
      const result = await twilioService.sendOTP(phone, 'phone');
      
      if (!result.success) {
        throw new Error(result.error || 'Failed to send OTP');
      }

      return { 
        data: {
          otpId: result.otpId,
          expiresAt: result.expiresAt
        }, 
        error: null 
      };
    } catch (error) {
      console.error("Phone OTP send error:", error);
      return { data: null, error };
    }
  }

  /**
   * OTP 검증
   * @param {string} phone - 전화번호
   * @param {string} code - OTP 코드
   * @returns {Promise<{data: any, error: any}>}
   */
  async verifyOTP(phone, code) {
    try {
      const result = await twilioService.verifyOTP(phone, code, 'phone');
      
      if (!result.success) {
        throw new Error(result.error || 'Invalid verification code');
      }

      // 인증 성공 시 사용자 메타데이터 업데이트
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        await supabase.auth.updateUser({
          data: { 
            phone: phone,
            phoneVerified: true,
            phoneVerifiedAt: new Date().toISOString()
          }
        });
      }

      return { 
        data: {
          verified: true,
          message: result.message
        }, 
        error: null 
      };
    } catch (error) {
      console.error("OTP verification error:", error);
      return { data: null, error };
    }
  }

  /**
   * OTP 재발송
   * @param {string} phone - 전화번호
   * @returns {Promise<{data: any, error: any}>}
   */
  async resendOTP(phone) {
    try {
      const result = await twilioService.resendOTP(phone, 'phone');
      
      if (!result.success) {
        throw new Error(result.error || 'Failed to resend OTP');
      }

      return { 
        data: {
          otpId: result.otpId,
          expiresAt: result.expiresAt
        }, 
        error: null 
      };
    } catch (error) {
      console.error("OTP resend error:", error);
      return { data: null, error };
    }
  }
}

export const phoneAuthService = new PhoneAuthService();